// indetificationTypes
export const identificationTypes = [
    {value: 'CC', text: 'CC - Cédula de ciudadanía', recibeEntrega: true },
    {value: 'RC', text: 'RC - Registro Civil de Nacimiento', recibeEntrega: false },
    {value: 'TI', text: 'TI - Tarjeta de Identidad', recibeEntrega: true },
    {value: 'CE', text: 'CE - Cédula de Extranjería', recibeEntrega: true },
    {value: 'PA', text: 'PA - Pasaporte', recibeEntrega: true },
    {value: 'NV', text: 'NV - Nacido Vivo', recibeEntrega: false },
    {value: 'CD', text: 'CD - Carné Diplomatico', recibeEntrega: true },
    {value: 'SC', text: 'SC - Salvoconducto de Permanencia', recibeEntrega: true },
    {value: 'PR', text: 'PR - Pasaporte de la ONU', recibeEntrega: true },
    {value: 'PE', text: 'PE - Permiso Especial de Permanencia', recibeEntrega: true },
    {value: 'AS', text: 'AS - Adulto sin Identificación', recibeEntrega: true },
    {value: 'MS', text: 'MS - Menor sin Identificación', recibeEntrega: false },
    {value: 'PT', text: 'PT - Permiso por Protección Temporal', recibeEntrega: true }
]
